import React, { FunctionComponent } from 'react';
import { Dialog, Table } from '../../../../tailwindcomponents';
import { LinePackageOverviewObj } from '../../../../types/line';

type PriorityItemsDialogProps = {
  visible: boolean;
  reports: Array<LinePackageOverviewObj>;
  headers: Array<string>;
  generateTableBody: (row: LinePackageOverviewObj, index: number, rowsInView: Array<LinePackageOverviewObj>) => React.ReactElement;
  onClose: () => void;
};

const PriorityItemsDialog: FunctionComponent<PriorityItemsDialogProps> = ({
  visible,
  reports,
  headers,
  generateTableBody,
  onClose,
}) => {
  const priorityReports = reports.filter(s => s.task_priority !== null && s.task_priority !== undefined && s.task_priority !== "");

  return (
    <Dialog
      visible={visible}
      max_width={"xl"}
      title={`Priority items (${priorityReports.length})`}
      context={
        <div>
          <Table
            headers={headers}
            rows={priorityReports}
            generateBody={(row: LinePackageOverviewObj, index: number) => generateTableBody(row, index - 1, priorityReports)}
            pagination={false}
            skipIndexCol={true}
          />
        </div>
      }
      onClose={() => onClose()}
      strict={false}
      show_options={false}
    />
  );
};

export default PriorityItemsDialog;
